import dayjs from "dayjs";
import { DateRangeFilter, DateFilterType } from "interfaces/filters";
import {
	ReservationsTabValue,
	ReservationStatusSelectOption,
	RESERVATION_STATUSES,
	ReservationsTab,
} from "interfaces/reservations";

// Canonical reservation status options used by every status filter UI.
// Order is fixed: Accepted, Cancelled, Pending, Expired.
export const reservationStatusesList: ReservationStatusSelectOption[] = [
	{ value: RESERVATION_STATUSES.ACCEPTED, label: "Accepted" },
	{ value: RESERVATION_STATUSES.CANCELLED, label: "Cancelled" },
	{ value: RESERVATION_STATUSES.PENDING, label: "Pending" },
	{ value: RESERVATION_STATUSES.EXPIRED, label: "Expired" },
];

export const defaultReservationsDateFilter = {
	dateFrom: dayjs().startOf("month").toISOString(),
	dateTo: dayjs().endOf("month").toISOString(),
	dateFromType: DateFilterType.CHECKOUT_TIME,
	dateToType: DateFilterType.CHECKOUT_TIME,
} as DateRangeFilter;

export const reservationsPageTabs = [
	{
		title: "Table",
		value: ReservationsTabValue.TABLE,
	},
	{
		title: "Calendar",
		value: ReservationsTabValue.CALENDAR,
	},
] as Array<ReservationsTab>;
